'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flex');